export enum UserRoleEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  TENANT_USER = 'TENANT_USER',
  TENANT_ADMIN = 'TENANT_ADMIN',
  RESELLER_ADMIN = 'RESELLER_ADMIN',
}
